import React from 'react';
import { FormData } from '../types';
import { initials } from '../utils/format';
interface LoanHeaderProps {
  values: FormData;
}
export function LoanHeader({
  values
}: LoanHeaderProps) {
  const borrower = String(values.loanName || 'Loan');
  const loanNumber = String(values.rcmLoanNumber || '');
  const stage = String(values.workflowStatus || '');
  return <header className="overflow-hidden rounded-2xl border border-slate-200 bg-slate-900 shadow-sm" data-id="element-268" data-mp="2zulnwarl9df5">
      <div className="flex flex-wrap items-center gap-4 px-6 py-5" data-id="element-269" data-mp="2qw9ww7mt8dm6">
        <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-600 text-base font-bold text-white" data-id="element-270" data-mp="2qxl128k63ndt">
          {initials(borrower.replace(',', ''))}
        </span>
        <div className="min-w-0 flex-1" data-id="element-271" data-mp="2gyvkcj40c8z5">
          <div className="flex items-center gap-2" data-id="element-272" data-mp="b55k7zkx5lkk">
            <p className="text-[11px] font-semibold uppercase tracking-widest text-blue-300" data-id="element-273" data-mp="b6gnlyagcrb5">
              Loan Record
            </p>
            <span className="rounded-full bg-white/10 px-2 py-0.5 text-[11px] font-medium text-slate-200" data-id="element-274" data-mp="f4ef57rp3php">
              {String(values.loanRecordType || 'Refinance')}
            </span>
          </div>
          <h1 className="truncate text-xl font-bold text-white" data-id="element-275" data-mp="1r6bgyx7w5wi3">{borrower}</h1>
        </div>
        <div className="flex flex-col items-end gap-1" data-id="element-276" data-mp="25z51ix20t2tm">
          {stage && <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500/15 px-3 py-1 text-sm font-semibold text-emerald-300" data-id="element-277" data-mp="20yr0w02r0v5m">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" data-id="element-278" data-mp="189jru75o4n64" />
              {stage}
            </span>}
          {loanNumber && <span className="font-mono text-xs text-slate-400" data-id="element-279" data-mp="1n7c8j2mybhlw">#{loanNumber}</span>}
        </div>
      </div>
    </header>;
}